(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-lp-form"] && !Shopify.designMode) return;
  try {
    
 jQuery(document).ready(function () {
    jQuery("#ctm_learn_more_form").validate({
        rules: {
            first_name: { required: true, maxlength: 40 },
            last_name: { required: true, maxlength: 80 },
            email: { required: true, email: true, maxlength: 80 },
            phone: { 
                required: true, 
                phoneFormat: true,
                maxlength: 40
            },
            company: { required: true, maxlength: 40 }
            //products: { required: false },
            //about: { required: false }
        },
        messages: {
            first_name: "Please enter your first name",
            last_name: "Please enter your last name",
            email: "Please enter a valid email address",
            phone: {
                required: "Please enter your phone number",
                phoneFormat: "Only numbers, spaces, +, and () are allowed"
            },
            company: "Please enter your company name",
            //products: "Please select a product interest"
        },
        errorClass: "error-message",
        errorPlacement: function (error, element) {
            if (element.closest(".select").length) {
                error.insertAfter(element.closest(".select"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
          const formData = new FormData(form);
          const $submitBtn = $(".action-button");

          $.ajax({
              url: "https://phpstack-1419362-5287618.cloudwaysapps.com/api/learn-more-submit",
              type: "POST",
              data: formData,
              contentType: false,
              processData: false,
              beforeSend: function () {
                  $submitBtn.prop("disabled", true).val("Submitting...");
              },

              success: function (response) {

                  $submitBtn.prop("disabled", false).val("Submit");

                  if (response && response.status) {
                      form.reset();
                      /*$(".ctm_overlay").addClass("ctm_overlay_open");
                      $("#thank-you-message")
                        .fadeIn()
                        .delay(3000)
                        .fadeOut(function () {
                            $(".ctm_overlay").removeClass("ctm_overlay_open");
                        });*/

                        /* redirect to success page */
                        const sectionNode = document.getElementById('success-url');
                        const successUrl = sectionNode.getAttribute('data-success-url');
                        window.location.href = successUrl;
                  } else {
                    alert("Something went wrong. Please try again.");
                  }
              },

              error: function () {
                $submitBtn.prop("disabled", false).val("Submit");
                alert("Server error. Please try again later.");
              }

          });

          return false;
        }
    });

    // Custom phone format method
    jQuery.validator.addMethod("phoneFormat", function (value, element) {
        return this.optional(element) || /^[0-9\-\+\s\(\)]+$/.test(value);
    }, "Invalid phone number format");
});

jQuery(document).ready(function () {
    // Function to check URL parameter
   /* function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }*/

    /*// Check if success=true is present in URL
    if (getParameterByName('success') === 'true') {
        jQuery(".ctm_overlay").addClass("ctm_overlay_open");
        jQuery("#thank-you-message").fadeIn().delay(3000).fadeOut(function () {
            jQuery(".ctm_overlay").removeClass("ctm_overlay_open");
        });
    }*/
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

//Header menu hover 
  let items = document.querySelector(".header__inline-menu").querySelectorAll("details");
  console.log(items)
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });
  
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-bg-field"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  $('.hero-form').validate({
    rules: {
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      email: 'Please enter a valid email address'
    },
    errorClass: 'contact__field-error',
    submitHandler: function (form) {
      const formData = new FormData(form);
      const $submitBtn = $('.lp_header_submit');

      $.ajax({
        url: 'https://phpstack-1419362-5287618.cloudwaysapps.com/api/lp-form-submit',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $submitBtn.prop('disabled', true).text('Submitting...');
          $('.contact__field-error').remove();
        },
        success: function (response) {
          $submitBtn.prop('disabled', false).text('Continue');
          if (response && response.status) {
            form.reset();
            /* redirect to success page 
            window.location.href = "https://b2b.solm.com/pages/success";*/
            /* redirect to success page */
                const sectionNode = document.getElementById('success-url');
                const successUrl = sectionNode.getAttribute('data-success-url');
                window.location.href = successUrl;
          } else {
            alert('Something went wrong. Please try again.');
          }
        },
        error: function () {
          $submitBtn.prop('disabled', false).text('Continue');
          alert('Server error. Please try again later.');
        }
      });
    return false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-bg-form-4"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  $('#LPHeader_Form').validate({
    rules: {
      full_name: {
        required: true,
        minlength: 2
      },
      email: {
        required: true,
        email: true
      },
      companyType: {
        required: true
      }
    },
    messages: {
      full_name: 'Please enter your full name',
      email: 'Please enter a valid email address',
      companyType: 'Please select your business type'
    },
    errorClass: 'contact__field-error',
    submitHandler: function (form) {
      const formData = new FormData(form);
      const $submitBtn = $('.lp_header_submit');

      $.ajax({
        url: 'https://phpstack-1419362-5287618.cloudwaysapps.com/api/lp-form-submit',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $submitBtn.prop('disabled', true).text('Submitting...');
          $('.contact__field-error').remove();
        },
        success: function (response) {
          $submitBtn.prop('disabled', false).text('Continue');
          if (response && response.status) {
            form.reset();
            /* redirect to success page 
            window.location.href = "https://b2b.solm.com/pages/success";*/
            /* redirect to success page */
                const sectionNode = document.getElementById('success-url');
                const successUrl = sectionNode.getAttribute('data-success-url');
                window.location.href = successUrl;
          } else {
            alert('Something went wrong. Please try again.');
          }
        },
        error: function () {
          $submitBtn.prop('disabled', false).text('Continue');
          alert('Server error. Please try again later.');
        }
      });
    return false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-bg-form"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  $('#LPHeader_Form').validate({
    rules: {
      full_name: {
        required: true,
        minlength: 2
      },
      email: {
        required: true,
        email: true
      },
      companyType: {
        required: true
      }
    },
    messages: {
      full_name: 'Please enter your full name',
      email: 'Please enter a valid email address',
      companyType: 'Please select your business type'
    },
    errorClass: 'contact__field-error',
    submitHandler: function (form) {
      const formData = new FormData(form);
      const $submitBtn = $('.lp_header_submit');

      $.ajax({
        url: 'https://phpstack-1419362-5287618.cloudwaysapps.com/api/lp-form-submit',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $submitBtn.prop('disabled', true).text('Submitting...');
          $('.contact__field-error').remove();
        },
        success: function (response) {
          $submitBtn.prop('disabled', false).text('Continue');
          if (response && response.status) {
            form.reset();
            /* redirect to success page 
            window.location.href = "https://b2b.solm.com/pages/success";*/
            /* redirect to success page */
                const sectionNode = document.getElementById('success-url');
                const successUrl = sectionNode.getAttribute('data-success-url');
                window.location.href = successUrl;
          } else {
            alert('Something went wrong. Please try again.');
          }
        },
        error: function () {
          $submitBtn.prop('disabled', false).text('Continue');
          alert('Server error. Please try again later.');
        }
      });
    return false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-bg-section"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  $('.hero-form').validate({
    rules: {
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      email: 'Please enter a valid email address'
    },
    errorClass: 'contact__field-error',
    submitHandler: function (form) {
      const formData = new FormData(form);
      const $submitBtn = $('.lp_header_submit');

      $.ajax({
        url: 'https://phpstack-1419362-5287618.cloudwaysapps.com/api/lp-form-submit',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $submitBtn.prop('disabled', true).text('Submitting...');
          $('.contact__field-error').remove();
        },
        success: function (response) {
          $submitBtn.prop('disabled', false).text('Continue');
          if (response && response.status) {
            form.reset();
            /* redirect to success page 
            window.location.href = "https://b2b.solm.com/pages/success";*/
            /* redirect to success page */
                const sectionNode = document.getElementById('success-url');
                const successUrl = sectionNode.getAttribute('data-success-url');
                window.location.href = successUrl;
          } else {
            alert('Something went wrong. Please try again.');
          }
        },
        error: function () {
          $submitBtn.prop('disabled', false).text('Continue');
          alert('Server error. Please try again later.');
        }
      });
    return false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["learn-more"] && !Shopify.designMode) return;
  try {
    
 jQuery(document).ready(function () {
    jQuery("#ctm_learn_more_form").validate({
        rules: {
            first_name: { required: true, maxlength: 40 },
            last_name: { required: true, maxlength: 80 },
            email: { required: true, email: true, maxlength: 80 },
            phone: { 
                required: true, 
                phoneFormat: true,
                maxlength: 40
            },
            company: { required: true, maxlength: 40 },
            title: { maxlength: 40 },
            "00NP8000009YOyn": { required: true } // Product Interest
        },
        messages: {
            first_name: "Please enter your first name",
            last_name: "Please enter your last name",
            email: "Please enter a valid email address",
            phone: {
                required: "Please enter your phone number",
                phoneFormat: "Only numbers, spaces, +, and () are allowed"
            },
            company: "Please enter your company name",
            title: "Maximum 40 characters",
            "00NP8000009YOyn": "Please select a product interest"
        },
        errorClass: "error-message",
        errorPlacement: function (error, element) {
            if (element.closest(".select").length) {
                error.insertAfter(element.closest(".select"));
            } else {
                error.insertAfter(element);
            }
        },
        submitHandler: function (form) {
          const formData = new FormData(form);
          const $submitBtn = $(".action-button");

          $.ajax({
            url: "https://phpstack-1419362-5287618.cloudwaysapps.com/api/learn-more-submit",
            type: "POST",
            data: formData,
            contentType: false,
            processData: false,
            beforeSend: function () {
                $submitBtn.prop("disabled", true).val("Submitting...");
            },
            success: function (response) {
                $submitBtn.prop("disabled", false).val("Submit");
                if (response && response.status) {
                  form.reset();
                  $(".ctm_overlay").addClass("ctm_overlay_open");
                  $("#thank-you-message")
                    .fadeIn()
                    .delay(3000)
                    .fadeOut(function () {
                        $(".ctm_overlay").removeClass("ctm_overlay_open");
                    });
                } else {
                  alert("Something went wrong. Please try again.");
                }
            },
            error: function () {
              $submitBtn.prop("disabled", false).val("Submit");
              alert("Server error. Please try again later.");
            }
          });

          return false;
        }
    });

    // Custom phone format method
    jQuery.validator.addMethod("phoneFormat", function (value, element) {
        return this.optional(element) || /^[0-9\-\+\s\(\)]+$/.test(value);
    }, "Invalid phone number format");
});

jQuery(document).ready(function () {
    // Function to check URL parameter
    function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    // Check if success=true is present in URL
    if (getParameterByName('success') === 'true') {
        jQuery(".ctm_overlay").addClass("ctm_overlay_open");
        jQuery("#thank-you-message").fadeIn().delay(3000).fadeOut(function () {
            jQuery(".ctm_overlay").removeClass("ctm_overlay_open");
        });
    }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-modal-popup"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {

  $('.hero-form').validate({
    rules: {
      email: {
        required: true,
        email: true
      }
    },
    messages: {
      email: 'Please enter a valid email address'
    },
    errorClass: 'contact__field-error',
    submitHandler: function (form) {
      const formData = new FormData(form);
      const $submitBtn = $('.lp_header_submit');

      $.ajax({
        url: 'https://phpstack-1419362-5287618.cloudwaysapps.com/api/lp-form-submit',
        type: 'POST',
        data: formData,
        contentType: false,
        processData: false,
        beforeSend: function () {
          $submitBtn.prop('disabled', true).text('Submitting...');
          $('.contact__field-error').remove();
        },
        success: function (response) {
          $submitBtn.prop('disabled', false).text('Continue');
          if (response && response.status) {
            form.reset();
           /* redirect to success page 
            window.location.href = "https://b2b.solm.com/pages/success";*/
            /* redirect to success page */
                const sectionNode = document.getElementById('success-url');
                const successUrl = sectionNode.getAttribute('data-success-url');
                window.location.href = successUrl;
          } else {
            alert('Something went wrong. Please try again.');
          }
        },
        error: function () {
          $submitBtn.prop('disabled', false).text('Continue');
          alert('Server error. Please try again later.');
        }
      });
    return false;
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-new-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const header = document.getElementById('lpHeader');
    if (!header) return;

    const stickyOffset = header.offsetTop;

    window.addEventListener('scroll', function () {
      if (window.scrollY > stickyOffset) {
        header.classList.add('is-fixed');
      } else {
        header.classList.remove('is-fixed');
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
